import { SUPPLIER_QUOTE_REQUEST_TYPE_ID } from "@grafit/shared/domain/supplier-quote-request/supplier-quote-request";
import { nonEmptyArrayParser, tidSchemaFactory } from "@grafit/shared/utils/validation";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ConsultationVersionedProjectGuard } from "../../../../features/supplier-quote-request/consultation-version-guard";
import { SupplierQuoteRequestPage } from "../../../../pages/supplier-quote-request-page/supplier-quote-request-page";

export const Route = createFileRoute("/_auth/_project/supplier-quote-request/$projectId/$subProjectId/")({
  component: () => (
    <ConsultationVersionedProjectGuard>
      <SupplierQuoteRequestPage />
    </ConsultationVersionedProjectGuard>
  ),
  validateSearch: z.object({
    createdSqrIds: nonEmptyArrayParser(tidSchemaFactory(SUPPLIER_QUOTE_REQUEST_TYPE_ID)).optional().catch(undefined),
  }),
});
